import { render, staticRenderFns } from "./AuthModal.html?vue&type=template&id=654452c4&scoped=true&"
import script from "./AuthModal.ts?vue&type=script&lang=ts&"
export * from "./AuthModal.ts?vue&type=script&lang=ts&"
import style0 from "./AuthModal.scss?vue&type=style&index=0&id=654452c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654452c4",
  null
  
)

export default component.exports